// //import '@vaadin/menu-bar';
// import { html, LitElement } from 'lit';
// import { customElement, state } from 'lit/decorators.js';

// //import { applyTheme } from 'Frontend/generated/theme';

// //import '@vaadin/vaadin-lumo-styles/style';

// @customElement('menu-bar-drop-down-indicators')
// export class Example extends LitElement {
//   protected override createRenderRoot() {    
//     const root = super.createRenderRoot();   
//     return root;
//   }

//   @state()
//   private items = [
//     { text: 'View' },
//     { text: 'Edit' },
//     {
//       text: 'Share',
//       children: [
//         {
//           text: 'On social media',
//           children: [{ text: 'Facebook' }, { text: 'Twitter' }, { text: 'Instagram' }],
//         },
//         { text: 'By email' },
//         { text: 'Get link' },
//       ],
//     },
//     {
//       text: 'Move',
//       children: [{ text: 'To folder' }, { text: 'To trash' }],
//     },
//     { text: 'Duplicate' },
//   ];

//   protected override render() {
//     return html`
//       <vaadin-menu-bar .items="${this.items}" theme="dropdown-indicators"></vaadin-menu-bar>
//     `;
//   }
// }

export var thisclass = {
    makeMenuBar: function (args: any) {
        (window as any).ood(args.id, document.createElement('menu-bar-drop-down-indicators'));
    }
}

